<template>
  <div
    :class="['range-input', { 'range-input-width': !autoWidth }]"
    v-byted-clickoutside="clickOutsideHandler"
  >
    <byted-popover
      popper-class="popover-rewrite"
      placement="bottom-start"
      trigger="click"
      width="310px"
      :arrow="false"
      transfer
    >
      <div @click="stopPropagation" class="range-panel" slot="body">
        <!-- 类型选择区域 -->
        <div class="range-type-area">
          <div
            v-for="item in rangeTypeItemList"
            :key="item.type"
            @click="rangeTypeItemClickHandler(item.type)"
            class="range-type-item"
            :style="{ color: getRangeTypeItemColor(item.type) }"
          >
            <span>{{ item.label }}</span>
            <byted-icon
              name="angle-right"
              :color="getRangeTypeItemColor(item.type)"
            ></byted-icon>
          </div>
        </div>
        <!-- 输入区 -->
        <div class="range-input-area" v-if="isRangeInputShow">
          <!-- 实际输入 -->
          <div
            v-if="isNowBetween"
            :class="['actual-input', { error: inputStartErrorTip }]"
          >
            <byted-input
              size="xs"
              v-model="inputMinValue"
              placeholder="请输入"
            ></byted-input>
            <span style="margin: 0 4px">-</span>
          </div>
          <div :class="['actual-input', { error: inputEndErrorTip }]">
            <byted-input
              size="xs"
              v-model="inputRangeValue"
              placeholder="请输入"
            ></byted-input>
            <span style="margin-left: 4px">{{ value.unit }}</span>
          </div>
          <!-- 校验错误提示 -->
          <div class="error-box">
            <div v-if="isNowBetween" class="error-tip error-tip-min">
              {{ inputStartErrorTip }}
            </div>
            <div class="error-tip">
              {{ inputEndErrorTip }}
            </div>
          </div>
          <!-- 应用btn -->
          <div class="apply-btn-area">
            <byted-button
              :disabled="disabledSubmit"
              type="primary"
              @click="applyBtnClickHandler"
              >{{ $bp_t("应用", "common.application") }}</byted-button
            >
          </div>
        </div>
      </div>
      <div
        slot="reference"
        :class="[
          {
            'fake-input-active': isRangePanelShow,
            'fake-filter-search': filterSearchBox,
          },
          'fake-input',
        ]"
        @click="fakeInputClickHandler"
      >
        <div class="fake-input-placeholder" v-if="!rangeValueString">
          {{ $bp_t("请选择", "common.please_choose") }}
        </div>
        <div
          :class="['fake-input-value', { 'fake-input-value': !autoWidth }]"
          v-else
        >
          {{ rangeValueString }}
        </div>
        <byted-icon
          :width="filterSearchBox ? '14px' : '12px'"
          :height="filterSearchBox ? '14px' : '12px'"
          name="angle-down"
          color="#999"
          :class="{
            'deg-180': isRangePanelShow,
            'position-right-0': filterSearchBox,
          }"
        ></byted-icon>
      </div>
    </byted-popover>
    <!-- 用一个假的div触发点击来将其消失 -->
    <div ref="fakeInput" />
  </div>
</template>

<script>
const rangeTypeConfigMap = {
  lower: { type: "lower", label: "大于等于" },
  upper: { type: "upper", label: "小于等于" },
  between: { type: "between", label: "介于" },
};
import * as reg from 'Src/util/regs.js'
export default {
  name: "automate-rule-input",
  props: {
    filterSearchBox: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({
        upper: "",
        lower: "",
        between: "",
        unit: "",
      }),
    },
    rangeTypeList: {
      type: Array,
      default: () => ["upper", "lower", "between"],
    },
    autoWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRangePanelShow: false,
      isRangeInputShow: false,
      selectedRangeType: "",
      inputMinValue: "",
      inputRangeValue: "",
      inputEndErrorTip: "",
      inputStartErrorTip: "",
    };
  },
  computed: {
    rangeValueString() {
      const { value } = this;
      if (this.isStartBetween) {
        return `${rangeTypeConfigMap.between.label} ${
          value[rangeTypeConfigMap.lower.type]
        }-${value[rangeTypeConfigMap.upper.type]} ${value.unit}`;
      }
      let curType = "";
      for (let type of this.rangeTypeList) {
        curType = value[type] ? type : curType;
      }
      return curType === ""
        ? ""
        : `${rangeTypeConfigMap[curType].label} ${value[curType]} ${value.unit}`;
    },
    rangeTypeItemList() {
      const list = [];
      this.rangeTypeList.map((type) => {
        list.push(rangeTypeConfigMap[type]);
      });
      return list;
    },
    isNowBetween() {
      return this.selectedRangeType === rangeTypeConfigMap.between.type;
    },
    isStartBetween() {
      const { value } = this;
      return (
        value[rangeTypeConfigMap.upper.type] &&
        value[rangeTypeConfigMap.lower.type]
      );
    },
    disabledSubmit() {
      return this.isNowBetween
        ? !(
            this.inputMinValue &&
            this.inputRangeValue &&
            !this.inputEndErrorTip &&
            !this.inputStartErrorTip
          )
        : !(
            this.inputRangeValue &&
            !this.inputStartErrorTip &&
            !this.inputEndErrorTip
          );
    },
  },
  watch: {
    inputRangeValue() {
      if (!this.inputRangeValue.length) {
        this.inputEndErrorTip = "";
        return;
      }
      this.inputEndErrorTip = this.inputValid(
        this.inputRangeValue,
        this.inputMinValue
      );
      this.inputStartErrorTip = this.inputValid(
        this.inputMinValue,
        this.inputRangeValue,
        true
      );
      if (
        this.inputEndErrorTip &&
        this.inputStartErrorTip === "值必须小于第二个值"
      ) {
        this.inputStartErrorTip = "";
      }
    },
    inputMinValue() {
      if (!this.inputMinValue.length) {
        this.inputStartErrorTip = "";
        return;
      }
      this.inputStartErrorTip = this.inputValid(
        this.inputMinValue,
        this.inputRangeValue,
        true
      );
      this.inputEndErrorTip = this.inputValid(
        this.inputRangeValue,
        this.inputMinValue
      );
      if (
        this.inputStartErrorTip &&
        this.inputEndErrorTip === "值必须大于第一个值"
      ) {
        this.inputEndErrorTip = "";
      }
    },
  },
  methods: {
    stopPropagation(e) {
      e.stopPropagation();
    },
    initData() {
      this.inputMinValue = "";
      this.inputRangeValue = "";
      this.inputEndErrorTip = "";
      this.isRangeInputShow = true;
      this.selectedRangeType = rangeTypeConfigMap[this.rangeTypeList[0]].type;
      if (this.isStartBetween) {
        this.inputRangeValue = this.value[rangeTypeConfigMap.upper.type];
        this.inputMinValue = this.value[rangeTypeConfigMap.lower.type];
        this.selectedRangeType = rangeTypeConfigMap.between.type;
        return;
      }
      if (this.value[rangeTypeConfigMap.upper.type]) {
        this.inputRangeValue = this.value[rangeTypeConfigMap.upper.type];
        this.selectedRangeType = rangeTypeConfigMap.upper.type;
        return;
      }
      if (this.value[rangeTypeConfigMap.lower.type]) {
        this.inputRangeValue = this.value[rangeTypeConfigMap.lower.type];
        this.selectedRangeType = rangeTypeConfigMap.lower.type;
        return;
      }
    },
    clickOutsideHandler() {
      // 点击input外面时
      this.isRangePanelShow = false;
    },
    fakeInputClickHandler() {
      // 数据的设置
      this.initData();
      // 控制panel的展开关闭
      this.isRangePanelShow = !this.isRangePanelShow;
    },
    rangeTypeItemClickHandler(rangeType) {
      if (this.selectedRangeType !== rangeType) {
        this.inputStartErrorTip = "";
        this.inputEndErrorTip = "";
        this.inputMinValue = "";
        this.inputRangeValue = "";
        this.selectedRangeType = rangeType;
        this.isRangeInputShow = true;
      }
    },
    getRangeTypeItemColor(rangeType) {
      return this.selectedRangeType === rangeType ? "#2F88FF" : "#333";
    },
    inputValid(value, minValue, valueRevert = false) {
      const { unit } = this.value;
      if (!value.length) {
        return "";
      }
      if (unit === "元") {
        if (
          value.length === 0 ||
          !reg.floatNumber.test(value) ||
          value > 9999999.99
        ) {
          return "请输入0~9999999.99的数字";
        }
        if (!reg.twoFloatNumber.test(value)) {
          return "最多两位小数";
        }
      } else if (unit === "%") {
        if (
          value.length === 0 ||
          !reg.floatNumber.test(value) ||
          Number(value) < 0 ||
          Number(value) > 100
        ) {
          return "请输入0~100的数字";
        }
        if (!reg.twoFloatNumber.test(value)) {
          return "最多两位小数";
        }
      } else if (unit === "个") {
        if (!reg.intNumber.test(value)) {
          return "请输入大于等于0的整数";
        }
        if (!reg.intHasMaxNumber.test(value)) {
          return "请输入0~999999999的数字";
        }
      }
      if (valueRevert) {
        [value, minValue] = [minValue, value];
      }
      if (value?.length && minValue?.length && +minValue >= +value) {
        return valueRevert ? "值必须小于第二个值" : "值必须大于第一个值";
      }
      return "";
    },
    applyBtnClickHandler() {
      if (this.inputEndErrorTip || this.inputStartErrorTip) {
        return;
      }
      this.isRangePanelShow = false;
      const changedValue = _.cloneDeep(this.value);
      this.rangeTypeList.map((type) => {
        changedValue[type] = "";
      });
      if (this.selectedRangeType === rangeTypeConfigMap.between.type) {
        changedValue[rangeTypeConfigMap.upper.type] = Number(
          this.inputRangeValue
        ).toString();
        changedValue[rangeTypeConfigMap.lower.type] = Number(
          this.inputMinValue
        ).toString();
      } else {
        changedValue[this.selectedRangeType] = Number(this.inputRangeValue).toString();
      }
      this.$emit("valueChanged", changedValue);
      this.$refs.fakeInput.click();
    },
  },
};
</script>
<style lang="scss">
.popover-rewrite {
  padding-top: 4px !important;
  .bui-popover-panel {
    padding: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
@import "src/basic/theme.scss";
.range-input-width {
  width: 190px;
}
.range-input {
  height: 30px;
  position: relative;
  /deep/.fake-filter-search {
    height: 30px !important;
    border: none !important;
    box-shadow: none !important;
    padding-left: 0px !important;
  }
  /deep/.position-right-0 {
    right: 0 !important;
  }
  /deep/.fake-input {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 4px 28px 4px 12px;
    cursor: pointer;
    font-size: 12px;
    .fake-input-placeholder {
      color: $color-text-holder;
    }
    .fake-input-value-width {
      width: 150px;
    }
    .fake-input-value {
      color: $color-border-underline;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .byted-icon {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      height: 14px;
      width: 18px;
      transition-duration: 0.2s;
      cursor: pointer;
    }

    .deg-180 {
      transform: rotate(180deg) translateY(50%);
      transition-duration: 0.2s;
    }

    &:hover {
      border-color: #2f88ff;
    }

    &.fake-input-active {
      border-color: #2f88ff;
      box-shadow: 0 0 0 2px rgba(47, 136, 255, 0.2);
    }
  }
}
.range-panel {
  height: 200px;
  background-color: $color-bg-container;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  z-index: 10;
  // position: absolute;
  // top: 34px;
  // left: 1px;
  display: -webkit-flex;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  .range-type-area {
    width: 110px;
    height: 200px;
    float: left;
    border-right: $color-border-block 1px solid;
    padding: 8px 0;
    .range-type-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      height: 28px;
      cursor: pointer;
      padding: 0 12px;
      color: $color-text-main;

      &:hover {
        color: $color-border-active;
      }

      .byted-icon {
        height: 14px;
        width: 14px;
      }
    }
  }

  .range-input-area {
    padding: 12px;
    width: 200px;
    height: 200px;
    float: left;
    font-size: 0;
    position: relative;
    .actual-input {
      font-size: 12px;
      height: 34px;
      display: inline-flex;
      align-items: center;
      .byted-input {
        width: 72px;
      }

      &.error .byted-input /deep/ input {
        border: $color-border-hint 1px solid;
        &:focus {
          box-shadow: 0 0 0 2px rgba(244, 88, 88, 0.2);
        }
      }
    }
    .error-box {
      display: flex;
      align-items: center;
      margin-top: 4px;
      padding-right: 16px;
      .error-tip-min {
        margin-right: 15.266px;
      }
      .error-tip {
        flex: 1;
        font-size: 12px;
        color: $color-border-hint;
        line-height: 20px;
      }
    }

    .apply-btn-area {
      position: absolute;
      bottom: 12px;
      right: 12px;

      .byted-button {
        padding: 0;
        margin: 0;
        min-width: 60px;
        height: 26px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;
      }
    }
  }
}

html {
  &:lang(en) {
    // 英文样式修复
    .range-input {
      .range-panel {
        .range-type-area {
          width: 136px;
        }
        .range-input-area {
          .actual-input {
            .byted-input {
              width: 100px;
            }
          }
          .apply-btn-area {
            .byted-button {
              min-width: auto;
              padding: 0 12px;
            }
          }
        }
      }
    }
  }
}
</style>